(function ($, Drupal) {
  Drupal.behaviors.CustomCursorV1 = {
    currentIndex: 0,
    cursorHeight: 10,
    attach: function (context) {
      var self = this;

      $('.js-custom-cursor-v1', context).each(function () {
        self.init($(this));
      });
    },
    init: function (element) {
      var self = this;
      var cursorImagesPath = $(element)
        .find('.js-custom-cursor-img img')
        .map(function () {
          return $(this).attr('src');
        })
        .get();

      self.cursorHeight = $(element).attr('data-cursor-height') || self.cursorHeight;
      if (cursorImagesPath.length) {
        let last = 0;

        document.addEventListener('mousemove', (e) => {
          const now = Date.now();

          if (now - last > 30) {
            self.createStar(e.clientX, e.clientY, cursorImagesPath);
            last = now;
          }
        });
      }
    },
    createStar: function (x, y, images) {
      var self = this;
      const star = document.createElement('div');

      star.className = 'custom-cursor';
      const size = self.cursorHeight;

      star.style.left = x + 'px';
      star.style.top = y + 'px';
      star.style.width = size + 'px';
      star.style.height = size + 'px';

      const imgSrc = images[self.currentIndex];

      self.currentIndex = (self.currentIndex + 1) % images.length;

      star.innerHTML = `
        <img
            src="${imgSrc}"
            width="${size}"
            height="${size}"
            draggable="false"
        />
      `;

      document.body.appendChild(star);
      setTimeout(() => {
        star.remove();
      }, 900);
    }
  };
})(jQuery, Drupal);
